import { customElement, html } from '@adobe/edex/ui/edex-lit';
import { EdexTagName, AdobeAnalyticsEvent } from '@adobe/edex/ui/shared/constants';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-star';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-star-outline';

import styles from '@adobe/edex/ui/components/shared/rating/rating.lit.scss';
import { classMap } from '@adobe/edex/ui/edex-lit';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { RatedPayload } from '@adobe/edex/ui/types/payload';
import { Analytics } from '@adobe/edex/ui/shared/config/analytics';

@customElement(EdexTagName.rating)
export class Rating extends BaseElement {
  static styles = styles;
  static get properties() {
    return {
      value: { type: Number },
      total: { type: Number },
      hideRating: { type: Boolean },
      readOnly: { type: Boolean },
      i18nLabel: { type: String },
    };
  }
  value: number;
  total: number;
  hideRating = false;
  readOnly = false;
  i18nLabel: string;

  chooseRating(rating: number) {
    Analytics.getInstance().emitEvent(AdobeAnalyticsEvent.resourceRate, 'Rate this resource');
    this.emitEvent<RatedPayload>('change', { rating });
  }

  render() {
    const { readOnly, value, hideRating, total, i18nLabel } = this;
    return html`
      <div class="rating">
        <div class="spectrum-Rating ${classMap({ 'is-readOnly': readOnly })}">
          ${[1, 2, 3, 4, 5].map((rating) => this.renderRatingStar(rating))}
        </div>
        ${!total
          ? null
          : html`
              <div class="rating-subtext">${total} ${$t(I18nKey.ratings)}</div>
            `}
        ${total || readOnly || !i18nLabel
          ? null
          : html`
              <div class="rating-subtext">${$t(i18nLabel)}</div>
            `}
      </div>
      ${!value || hideRating
        ? null
        : html`
            <span class="rating-average">${value}</span>
          `}
    `;
  }

  renderRatingStar(rating: number) {
    const { readOnly, value } = this;
    return html`
      <span
        @click="${readOnly ? null : () => this.chooseRating(rating)}"
        class="spectrum-Rating-icon ${classMap({
          'is-selected': value >= rating,
        })}"
      >
        <sp-icon class="spectrum-Icon spectrum-UIIcon-Star spectrum-Rating-starActive">
          <sp-icon-star></sp-icon-star>
        </sp-icon>
        <sp-icon class="spectrum-Icon spectrum-UIIcon-StarOutline spectrum-Rating-starInactive">
          <sp-icon-star-outline></sp-icon-star-outline>
        </sp-icon>
      </span>
    `;
  }
}
